import { BaseText, BaseView } from '@/components/base'
import { Warning } from '@/assets/icons'

export const ErrorOnLoadCurrenciesTemplate = () => (
  <BaseView center style={{ flexGrow: 1 }}>
    <Warning size={80} />

    <BaseText
      textAlign="center"
      color="label.description"
      style={{ marginTop: 16 }}
    >
      Service temporarily unavailable
    </BaseText>
  </BaseView>
)
